import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import Header from '../../../components/Header';
import { Main, MainContainer } from '../request/resume/RequestResume';
import { DateContainerInput, DateInput } from '../../../components/Header/Search/SearchStyles';
import { toastr } from 'react-redux-toastr';
import styled from 'styled-components';

const breadcrumb = [{ link: '', label: 'BI (v.beta)' }];

const DATE_MASK = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

function getPanelBaseUrl() {
  let baseUrl = process.env.REACT_APP_PANEL_URL;
  if (process.env.REACT_APP_ENV === 'prod') {
    baseUrl = process.env.REACT_APP_PANEL_URL_PROD;
  }
  return baseUrl ? baseUrl.replace(/\/$/, '') : '';
}

/** Converte dd/mm/yyyy para yyyy-mm-dd */
function toYmd(value) {
  if (!value || value.length !== 10) return null;
  const parts = value.split('/');
  if (parts.length !== 3) return null;
  const [d, m, y] = parts;
  if (!d || !m || !y || y.length !== 4) return null;
  return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
}

const FormRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
`;

const Label = styled.label`
  font-size: 0.9rem;
  color: ${props => props.theme.color_gray || '#6c757d'};
  min-width: 100px;
`;

const FieldWrap = styled.div`
  width: 180px;
`;

const SubmitButton = styled.button`
  padding: 8px 24px;
  font-size: 0.9rem;
  background-color: #152b4e;
  color: white;
  border: 1px solid #152b4e;
  cursor: pointer;
  font-family: 'Open Sans', sans-serif;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const FormCard = styled.div`
  max-width: 520px;
  padding: 24px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
`;

const AvisoFiltroDatas = styled.p`
  font-weight: bold;
  font-style: italic;
  font-size: 0.9rem;
  color: ${props => props.theme.color_gray || '#6c757d'};
  margin: 0 0 16px 0;
  flex: 1;
`;

const SpinnerBtn = styled.span`
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-left: 8px;
  vertical-align: middle;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;

class ExtracaoDados extends PureComponent {
  state = {
    dataInicial: '',
    dataFinal: '',
    extraindo: false
  };

  handleDataInicialChange = (e) => {
    this.setState({ dataInicial: e.target.value });
  };

  handleDataFinalChange = (e) => {
    this.setState({ dataFinal: e.target.value });
  };

  handleExtrair = (e) => {
    e.preventDefault();
    const { dataInicial, dataFinal } = this.state;
    const dataInicialYmd = toYmd(dataInicial);
    const dataFinalYmd = toYmd(dataFinal);

    if (!dataInicialYmd || !dataFinalYmd) {
      toastr.warning('Datas inválidas', 'Preencha data inicial e data final no formato dd/mm/aaaa.');
      return;
    }

    if (dataFinalYmd < dataInicialYmd) {
      toastr.warning('Datas inválidas', 'A data final deve ser igual ou posterior à data inicial.');
      return;
    }

    const baseUrl = getPanelBaseUrl();
    if (!baseUrl) {
      toastr.error('Configuração', 'URL do panel não configurada (REACT_APP_PANEL_URL).');
      return;
    }

    const login = this.props.login || {};
    const token = login.user && login.user.token && login.user.token.access_token;
    if (!token) {
      toastr.error('Autenticação', 'Sessão inválida. Faça login novamente.');
      return;
    }

    this.setState({ extraindo: true });

    const url = `${baseUrl}/api/perfis-inquilinos`;
    const headers = { Authorization: `Bearer ${token}` };
    const data = {
      data_inicial: dataInicialYmd,
      data_final: dataFinalYmd,
      exportar: 1
    };

    axios.post(url, data, { headers, responseType: 'blob' })
      .then((response) => {
        const contentType = (response.headers['content-type'] || '').toLowerCase();
        if (contentType.indexOf('application/json') !== -1) {
          return response.data.text().then((text) => {
            const json = JSON.parse(text);
            if (json.queued) {
              toastr.success('Extração', json.message || 'O relatório será enviado para o seu e-mail em breve.');
              return;
            }
          });
        }
        // Não veio queued -> é o arquivo, baixa
        const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const disposition = response.headers['content-disposition'];
        let filename = 'perfis_inquilinos.xlsx';
        if (disposition && disposition.indexOf('filename=') !== -1) {
          const match = disposition.match(/filename="?([^";]+)"?/);
          if (match) filename = match[1];
        }
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
        toastr.success('Extração', 'Arquivo baixado com sucesso.');
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          toastr.error('Autenticação', 'Token inválido ou expirado. Faça login no panel.');
        } else if (err.response && err.response.data instanceof Blob) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const msg = JSON.parse(reader.result);
              toastr.error('Erro', msg.message || 'Falha na extração.');
            } catch (e) {
              toastr.error('Erro', 'Falha na extração.');
            }
          };
          reader.readAsText(err.response.data);
        } else {
          toastr.error('Erro', err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Falha na extração.');
        }
      })
      .finally(() => {
        this.setState({ extraindo: false });
      });
  };

  render() {
    const { dataInicial, dataFinal } = this.state;
    const login = this.props.login || {};
    const user = login.user || {};
    const usuario = user.usuario || {};
    const isMaster = usuario.master === true;

    if (!isMaster) {
      return <Redirect to="/intranet/dashboard" />;
    }

    return (
      <Main>
        <Header
          breadcrumb={breadcrumb}
          title="EXTRAÇÃO DE DADOS"
          actualLink="Extração de Dados"
        />
        <MainContainer>
          <FormCard>
            <form onSubmit={this.handleExtrair}>
              <FormRow>
                <Label>Data inicial</Label>
                <FieldWrap>
                  <DateContainerInput style={{ width: '100%' }}>
                    <DateInput
                      value={dataInicial}
                      onChange={this.handleDataInicialChange}
                      placeholder="dd/mm/aaaa"
                      mask={DATE_MASK}
                    />
                  </DateContainerInput>
                </FieldWrap>
              </FormRow>
              <FormRow>
                <Label>Data final</Label>
                <FieldWrap>
                  <DateContainerInput style={{ width: '100%' }}>
                    <DateInput
                      value={dataFinal}
                      onChange={this.handleDataFinalChange}
                      placeholder="dd/mm/aaaa"
                      mask={DATE_MASK}
                    />
                  </DateContainerInput>
                </FieldWrap>
              </FormRow>
              <FormRow>
                <Label />
                <AvisoFiltroDatas>
                  Para filtros superiores à 1 ano será enviado o arquivo para o email do usuário solicitante, assim que o arquivo for gerado.
                </AvisoFiltroDatas>
              </FormRow>
              <FormRow>
                <Label />
                <SubmitButton type="submit" disabled={this.state.extraindo}>
                  {this.state.extraindo ? <span>Gerando... <SpinnerBtn /></span> : 'Gerar Relatório (Excel)'}
                </SubmitButton>
              </FormRow>
            </form>
          </FormCard>
        </MainContainer>
      </Main>
    );
  }
}

const mapStateToProps = (state) => ({
  login: state.login
});

export default connect(mapStateToProps)(ExtracaoDados);
